
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h2>Summer Camp </h2>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm register-summer-camp section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="sec-title text-center">
                <h2>Registration  <span >Form</span></h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/josh-summer-camp.jpg"
                        alt="GHRSCF" class="w-100">
                </div>
                <div class="widget_title inner-title mt-5">
                    <h4>TERMS AND CONDITIONS</h4>
                </div>
                <h6>Participants should bring the Following</h6>
                <ul class="list-style list-style1">
                    <li>Sport shoes / Canvas shoes</li>
                    <li>Water Bottles</li>
                    <li>Mask and Sanitizer</li>
                    <li>Snacks</li>
                </ul>
                <div class="widget_title inner-title">
                    <h4>Important Instructions:</h4>
                </div>
                <ul class="list-style list-style1">
                    <li>Jewellery (Gold, Silver (or) imitation), Money with participant is strictly not allowed.</li>
                    <li>Admission into the Camp is considered only after payment of entire FEE</li>
                    <li>The application forms duly filled in must be submitted along with 2 pass post size photographs
                    </li>
                    <li>Interested students can carry cameras and mobile phones at their own responsibility and Risk.
                    </li>
                    <li>Participants should strictly follow the instructions of the management staff and trainers.</li>
                    <li>Only parents or guardians should pick and drop the kid to the camp and register their attendance
                        daily at the counter by showing ID</li>
                    <li>Cancellation of admission is entirely at the discretion of Parents / Guardian.</li>
                    <li>Fee is non-refundable In case of cancellation.</li>
                    <!-- <li>No refund will take place in absence of 80% attendance&nbsp;</li> -->
                    <!-- <li>To claim refund of Rs. 500, minimum 80% attendance of the paticipants is a must.</li> -->
                    <li>The Camp organisers are not responsible for any kind of snacks or refreshment arrangements</li>
                    <li>Organisers have all the rights to make necessary changes in time table in case if required or in
                        emergency</li>
                </ul>
                <a routerLink="/photogallery" class="btn button--effect-2 mx-2 btn-color w-50 mt-5"> Go to Gallery
                    <i class="fa fa-angle-double-right mx-1" aria-hidden="true"></i>
                </a>
            </div>
            <div class="col-md-7">
                <form [formGroup]="registerForm" (ngSubmit)="submitForm()" class="row gx-3 comments-form contact-form">
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input wide form-group">
                            <input type="text" formControlName="studentName" id="studentName" class="form-control">
                            <label class="fw-bold">Name <span class="star">*</span></label>
                            <div *ngIf="f['studentName'].touched && f['studentName'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['studentName'].errors && f['studentName'].errors['required']">This Field
                                    is required.</div>
                                <div *ngIf="f['studentName'].errors && f['studentName'].errors['minlength']">Name should
                                    be 3 character.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="age" id="age" class="form-control">

                            <div *ngIf="f['age'].touched && f['age'].invalid" class="alert alert-danger">
                                <div *ngIf="f['age'].errors && f['age'].errors['required']">This Field is required.
                                </div>
                                <div *ngIf="f['age'].errors && f['age'].errors['minlength']">Age should be 3 character.
                                </div>
                            </div>
                            <label class="fw-bold">Age <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <select name="batch" formControlName="batch" required="required" id="batch"
                                class="form-control">
                                <option value="">-- Select Batch--</option>
                                <option value="first">First Batch</option>
                                <option value="second">Second Batch</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <select name="blood_group" formControlName="blood_group" required="required"
                                id="blood_group" class="form-control">
                                <option value="">-- Select Blood Group --</option>
                                <option value="A+">A+</option>
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="styled-input">
                            <input type="text" formControlName="instituteName" id="instituteName"
                                class="form-control" />
                            <div *ngIf="f['instituteName'].touched && f['instituteName'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['instituteName'].errors && f['instituteName'].errors['required']">
                                    College/Institute Name is required.</div>
                                <div *ngIf="f['instituteName'].errors && f['instituteName'].errors['minlength']">
                                    College/Institute Name should be 3 character.</div>
                            </div>
                            <label class="fw-bold">School/College/Academy Name <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="styled-input wide">
                            <textarea formControlName="address" id="address" class="form-control"></textarea>
                            <div *ngIf="f['address'].touched && f['address'].invalid" class="alert alert-danger">
                                <div *ngIf="f['address'].errors && f['address'].errors['required']">This Field is
                                    required.</div>
                                <div *ngIf="f['address'].errors && f['address'].errors['minlength']">Address should be 3
                                    character.</div>
                            </div>

                            <label class="fw-bold">Address <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="zip" maxlength="6" id="zip" class="form-control" />
                            <div *ngIf="f['zip'].touched && f['zip'].invalid" class="alert alert-danger">
                                <div *ngIf="f['zip'].errors && f['zip'].errors['required']">This Field is required.
                                </div>
                                <div *ngIf="f['zip'].errors && f['zip'].errors['minlength']">Pincode should be 3
                                    character.</div>
                            </div>
                            <label class="fw-bold">Pincode <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="parent_mobileNo" maxlength="10" id="parent_mobileNo"
                                class="form-control" />
                            <div *ngIf="f['parent_mobileNo'].touched && f['parent_mobileNo'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['parent_mobileNo'].errors && f['parent_mobileNo'].errors['required']">This
                                    Field Mobile No is required.</div>
                                <div *ngIf="f['parent_mobileNo'].errors && f['parent_mobileNo'].errors['minlength']">
                                    Parent Mobile No should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Parent's Mobile Number <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="stud_email" id="stud_email" class="form-control" />
                            <div *ngIf="f['stud_email'].touched && f['stud_email'].invalid" class="alert alert-danger">
                                <div *ngIf="f['stud_email'].errors && f['stud_email'].errors['required']">This Field is
                                    required.</div>
                                <div *ngIf="f['stud_email'].errors && f['stud_email'].errors['minlength']">Student
                                    Email-id should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Student's E-mail</label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="parent_email" id="parent_email" class="form-control" />
                            <div *ngIf="f['parent_email'].touched && f['parent_email'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['parent_email'].errors && f['parent_email'].errors['required']">This Field
                                    is required.</div>
                                <div *ngIf="f['parent_email'].errors && f['parent_email'].errors['minlength']">Parent
                                    Email should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Parent's E-mail <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="styled-input wide">
                            <input type="text" formControlName="first_guardian" id="first_guardian"
                                class="form-control" />
                            <div *ngIf="f['first_guardian'].touched && f['first_guardian'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['first_guardian'].errors && f['first_guardian'].errors['required']">This
                                    Field is required.</div>
                                <div *ngIf="f['first_guardian'].errors && f['first_guardian'].errors['minlength']">Firts
                                    Guardian should be 3 character.</div>
                            </div>
                            <label class="fw-bold">1st Parent/Guardian Name <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="first_cell_phone" maxlength="10" id="first_cell_phone"
                                class="form-control" />
                            <div *ngIf="f['first_cell_phone'].touched && f['first_cell_phone'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['first_cell_phone'].errors && f['first_cell_phone'].errors['required']">
                                    This Field is required.</div>
                                <div *ngIf="f['first_cell_phone'].errors && f['first_cell_phone'].errors['minlength']">
                                    Phone No should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Cell Phone <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="first_work_place" id="first_work_place"
                                class="form-control" />
                            <div *ngIf="f['first_work_place'].touched && f['first_work_place'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['first_work_place'].errors && f['first_work_place'].errors['required']">
                                    This Field is required.</div>
                                <div *ngIf="f['first_work_place'].errors && f['first_work_place'].errors['minlength']">
                                    Place should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Place of Work <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="first_work_phone" maxlength="10" id="first_work_phone"
                                class="form-control" />
                            <div *ngIf="f['first_work_phone'].touched && f['first_work_phone'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['first_work_phone'].errors && f['first_work_phone'].errors['required']">
                                    This Field is required.</div>
                                <div *ngIf="f['first_work_phone'].errors && f['first_work_phone'].errors['minlength']">
                                    Phone No. should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Work Phone <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="second_guardian" id="second_guardian"
                                class="form-control" />
                            <div *ngIf="f['second_guardian'].touched && f['second_guardian'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['second_guardian'].errors && f['second_guardian'].errors['required']">This
                                    Field is required.</div>
                                <div *ngIf="f['second_guardian'].errors && f['second_guardian'].errors['minlength']">
                                    Second Guardian should be 3 character.</div>
                            </div>
                            <label class="fw-bold">2nd Parent/Guardian Name</label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="sec_cell_phone" maxlength="10" id="sec_cell_phone"
                                class="form-control" />
                            <div *ngIf="f['sec_cell_phone'].touched && f['sec_cell_phone'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['sec_cell_phone'].errors && f['sec_cell_phone'].errors['required']">This
                                    Field is required.</div>
                                <div *ngIf="f['sec_cell_phone'].errors && f['sec_cell_phone'].errors['minlength']">Phone
                                    No. should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Cell Phone</label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="sec_work_place" id="sec_work_place"
                                class="form-control" />
                            <div *ngIf="f['sec_work_place'].touched && f['sec_work_place'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['sec_work_place'].errors && f['sec_work_place'].errors['required']">This
                                    Field is required.</div>
                                <div *ngIf="f['sec_work_place'].errors && f['sec_work_place'].errors['minlength']">Place
                                    should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Place of Work</label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="sec_work_phone" maxlength="10" id="sec_work_phone"
                                class="form-control" />
                            <div *ngIf="f['sec_work_phone'].touched && f['sec_work_phone'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['sec_work_phone'].errors && f['sec_work_phone'].errors['required']">This
                                    Field is required.</div>
                                <div *ngIf="f['sec_work_phone'].errors && f['sec_work_phone'].errors['minlength']">Place
                                    should be 3 character.</div>
                            </div>
                            <label class="fw-bold"> Work phone</label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="emr_contact" maxlength="10" id="emr_contact"
                                class="form-control" />
                            <div *ngIf="f['emr_contact'].touched && f['emr_contact'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['emr_contact'].errors && f['emr_contact'].errors['required']">This Field
                                    is required.</div>
                                <div *ngIf="f['emr_contact'].errors && f['emr_contact'].errors['minlength']">Contact
                                    should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Emergency Contact <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <input type="text" formControlName="relationship" id="relationship" class="form-control" />
                            <div *ngIf="f['relationship'].touched && f['relationship'].invalid"
                                class="alert alert-danger">
                                <div *ngIf="f['relationship'].errors && f['relationship'].errors['required']">This Field
                                    is required.</div>
                                <div *ngIf="f['relationship'].errors && f['relationship'].errors['minlength']">This
                                    Field should be 3 character.</div>
                            </div>
                            <label class="fw-bold">Relationship <span class="star">*</span></label>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="styled-input">
                            <select name="category_sport" formControlName="category_sport" id="category_sport"
                                class="form-control">
                                <option value="">-- Select Category of Sports --</option>
                                <option value="Football">Football</option>
                                <option value="Basketball">Basket Ball</option>
                                <option value="Badminton">Badminton</option>
                                <option value="Cricket">Cricket</option>
                                <option value="Archery">Archery</option>
                                <option value="Handball">Hand Ball</option>
                                <option value="Chess">Chess</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-12 col-sm-12">
                        <table class="table" style="border: 1px solid #000; padding: 5px">
                            <tbody>
                                <tr>
                                    <td colspan="3"><b>Name and phone number(s) of person(s) other than parents allowed
                                            to pick up you child</b></td>
                                </tr>
                                <tr>
                                    <td>1.</td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_one"
                                            name="pick_candidate_one" placeholder="Enter Name *" value="" required />
                                    </td>
                                    <td><input type="text" class="form-control" formControlName="pick_phone_one"
                                            maxlength="10" name="pick_phone_one" placeholder="Enter Phone *" value=""
                                            required /></td>
                                </tr>
                                <tr>
                                    <td>2.</td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_two"
                                            name="pick_candidate_two" placeholder="Enter Name" value="" /></td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_two"
                                            maxlength="10" name="pick_phone_two" placeholder="Enter Phone" value="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>3.</td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_three"
                                            name="pick_candidate_three" placeholder="Enter Name" value="" /></td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_three"
                                            maxlength="10" name="pick_phone_three" placeholder="Enter Phone" value="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>4.</td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_four"
                                            name="pick_candidate_four" placeholder="Enter Name" value="" /></td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_four"
                                            maxlength="10" name="pick_phone_four" placeholder="Enter Phone" value="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>5.</td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_five"
                                            name="pick_candidate_five" placeholder="Enter Name" value="" /></td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_five"
                                            maxlength="10" name="pick_phone_five" placeholder="Enter Phone" value="" />
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        Any special instructions, such as custody or restraining orders must be attached
                                        to this application and discussed personally with the camp director. All
                                        information will be kept confidential.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group">
                        <!-- <h6 class="mt-2">Please list any other information you'd like to include about you compare:</h6> -->
                        <div class="col-sm-12 mt-3">
                            <textarea id="message" name="message" formControlName="message" class="form-control"
                                placeholder="Message"></textarea>
                        </div>
                    </div>
                    <div class="form-group mt-2">
                        <input type="submit" name="submit" class="btn button--effect-1 w-50" value="Pay Rs.500"
                            id="send_button" />
                    </div>
                </form>
            </div>

        </div>
    </div>
</section>
